//*************************************************************************************
//* Session specific code
//*
//* 6/13/18 Kraus    [COM-136]: Created
//*************************************************************************************

app.ActivityLog = (function () {
    var options = [];
    var myActivityLog = {
        Init: function (gridId) {
            $("#divActivityLog").on('click', ".fa-chevron-down", function () {
                $(this).parent().next().slideDown(500);
                app.ActivityLog.GetActivityLogResults();
                $(this).parent().attr('title', 'Hide Activity Log');
                $(this).removeClass("fa-chevron-down");
                $(this).addClass("fa-chevron-up");
            });

            $("#divActivityLog").on('click', ".fa-chevron-up", function () {
                $(this).parent().next().slideUp(500);
                $(this).parent().attr('title', 'Show Activity Log');
                $(this).removeClass("fa-chevron-up");
                $(this).addClass("fa-chevron-down");
            });


            $("#grdActivityLog").kendoGrid({
                columns: [
                    {
                        field: "Id",
                        hidden: true
                    },
                    {
                        field: "Message",
                        title: "Message",
                        width: "100px"
                    },
                    {
                        field: "UserName",
                        title: "User Name",
                        width: "75px"
                    },
                    {
                        field: "Timestamp",
                        title: "Timestamp",
                        width: "100px"
                    },
                    {
                        field: "Before",
                        title: "Before",
                        encoded: false,
                        width: "400px"
                    },
                    {
                        field: "After",
                        title: "After",
                        encoded: false,
                        width: "400px"
                    }
                ],
                toolbar: ["excel"],
                excel: {
                    allpages: true,
                    fileName: $("#grdActivityLog").data("file-name")
                },
                scrollable: false,
                resizable: true,
                sortable: true,
                columnMenu: true,
                groupable: {
                    messages: {
                        empty: "Drop columns here to group by"
                    }
                }
            });
            app.KendoGrids.InitPersistentGrid("grdActivityLog", false);
        },
        GetActivityLogResults: function () {
            if ($("#grdActivityLog").css('display') == 'none' || $("#grdActivityLog").css("visibility") == "hidden") {
                return;
            }
            app.KendoGrids.GetResults("grdActivityLog");

            //kendo.ui.progress($('#grdActivityLog'), true);
            //$.ajax({
            //    type: 'POST',
            //    dataType: 'json',
            //    url: $('#grdActivityLog').data('url'),
            //    data: JSON.stringify({
            //        'logs': $('#grdActivityLog').data('logs'),
            //    }),
            //    contentType: "application/json; charset=utf-8",
            //    success: function (results) {
            //        var dataSource = new kendo.data.DataSource({ data: results });
            //        var grid = $('#grdActivityLog').data("kendoGrid");
            //        grid.setDataSource(dataSource);
            //        kendo.ui.progress($('#grdActivityLog'), false);
            //    },
            //    error: function (results) {
            //        kendo.ui.progress($('#grdActivityLog'), false);
            //    }
            //});
        }
    };
    return myActivityLog;
}());
